import { IsMobile } from "utils/is-mobile";

import { Grid } from "@material-ui/core";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";
import FromToDateField from "components/_refactor/fields/from-to-date";

const statusOptions = [
  { label: "Todos", value: "TODOS" },
  { label: "Cadastrado", value: "CADASTRADO" },
  { label: "Publicado", value: "PUBLICADO" },
  { label: "Finalizado", value: "FINALIZADO" },
  { label: "Ativo", value: "ATIVO" },
  { label: "Inativo", value: "INATIVO" },
];

export default function Filters({ isLoading, filters, setFilters }) {
  const isMobile = IsMobile();

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      <Grid item xs={12} md={6} lg={4} xl={2}>
        <InputText
          placeholder="Pesquisar por nome da vitrine"
          onChange={(e) => handleChange("vitrineName", e.target.value)}
          disabled={isLoading}
          required={false}
          value={filters.vitrineName}
          className="form-control"
          style={{ width: "100%" }}
          label="Nome da vitrine"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4} xl={2}>
        <AutoCompleteField
          options={statusOptions}
          label="Status"
          optionLabelKey="label"
          optionIdKey="value"
          onChange={(option) => handleChange("status", option)}
          disabled={isLoading}
          value={filters.status}
          required={false}
        />
      </Grid>
      <Grid item xs={12} md={12} lg={12} xl={8}>
        <FromToDateField
          label="Período de Vigência"
          disablePrefixLabels={true}
          initialDate={filters.initialDate}
          finalDate={filters.finalDate}
          disabled={isLoading}
          setInitialDate={(value) => handleChange("initialDate", value)}
          setFinalDate={(value) => handleChange("finalDate", value)}
          isMobile={isMobile}
          pattern="br"
        />
      </Grid>
    </>
  );
}
